import { SystemIcon } from '@volvo/vcdk-react/SystemIcon';

import HardwareHealthCheck from 'assets/volvoIcons/Tools/HardwareHealthCheck';
import { AreaName } from 'domain/constants';
import { TabConfiguration } from 'library/components/controls/layout/tabs/types';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import {
	UnitOverview_Services_HealthChecks,
	UnitOverview_Services_Repairs,
	UnitOverview_Services_ServiceAgreements,
	UnitOverview_Services_ServiceProtocols,
} from 'main/routes/urls/RouteUrls';

export const servicesAreaTabsConfiguration: TabConfiguration[] = [
	{
		title: 'productIndividual:repairs-title',
		path: UnitOverview_Services_Repairs,
		icon: <SystemIcon icon="wrench" aria-label="Repairs" />,
		areaSecurity: createArea(AreaName.Repair, OperationType.Read),
	},
	{
		title: 'drivelineview:protocolsSection',
		path: UnitOverview_Services_ServiceProtocols,
		icon: <SystemIcon icon="service" aria-label="Service Protocols" />,
		areaSecurity: createArea(AreaName.ServiceProtocol, OperationType.Read),
	},
	{
		title: 'unitOverview:service-agreements-title',
		path: UnitOverview_Services_ServiceAgreements,
		icon: <SystemIcon icon="handshake" aria-label="Service Agreements" />,
	},
	{
		title: 'unitOverview:health-checks-title',
		path: UnitOverview_Services_HealthChecks,
		icon: <HardwareHealthCheck aria-label="Health Checks" />,
		endDateNewBadge: new Date(2026, 10, 1),
		areaSecurity: createArea(AreaName.HealthCheck, OperationType.Read),
	},
];
